import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import parse from 'html-react-parser';
import EcomEngineAPI from 'api/ecom_engine_api';

export function ManageBooking({ message, content = '' }) {
  const email = useSelector((state) => state.user.email);
  const [submissionMessage, setSubmissionMessage] = useState(message);
  const [submissionClass, setSubmissionClass] = useState('alert-info');

  const onSubmit = (params, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);
    setSubmissionMessage(null);
    setSubmissionClass('alert-info');

    EcomEngineAPI.securePayment(params).then((result) => {
      setSubmitting(false);

      if (result.status && result.status >= 299) {
        setSubmissionMessage(result.message);
        setSubmissionClass('alert-danger');
      } else if (result.message) {
        setSubmissionMessage(result.message);
      }

      if (result.location) {
        window.location.assign(result.location);
      }
    });
  };

  const formSchema = Yup.object().shape({
    email: Yup.string().email().required('Please enter a valid email address'),
    reference: Yup.string()
      .length(6)
      .required('Your booking reference is a required field'),
  });

  return (
    <Formik
      initialValues={{
        email,
        reference: '',
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <div>
          <div className="mw--x-narrow content">{parse(content)}</div>
          <hr />
          <Form className="needs-validation manage-booking__form">
            {submissionMessage && (
              <div className="form-group row">
                <div className="col-12 col-sm-8 col-lg-5">
                  <div
                    className={`alert ${submissionClass} alert-dismissible fade show`}
                  >
                    {submissionMessage}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setSubmissionMessage(null);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="form-group row">
              <div className="col-12 col-sm-8 col-lg-5">
                <label htmlFor="email">Email Address</label>
                <Field
                  name="email"
                  className="form-control"
                  id="email"
                  placeholder="Email"
                  disabled={email ? 'disabled' : ''}
                />
                <ErrorMessage
                  className="text-danger text-small mt-1"
                  name="email"
                  component="div"
                  id="email_error"
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-12 col-sm-8 col-lg-5">
                <label htmlFor="reference">Booking Reference</label>
                <Field
                  name="reference"
                  className="form-control"
                  id="reference"
                  placeholder="Booking Reference (6 digit code)"
                />
                <ErrorMessage
                  className="text-danger text-small mt-1"
                  name="reference"
                  component="div"
                  id="reference_error"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="btn btn-primary mt-2"
            >
              {isSubmitting ? (
                <i className="fas fa-spinner-third animation-momentum-spin me-2" />
              ) : (
                ''
              )}
              Go
            </button>
          </Form>
        </div>
      )}
    </Formik>
  );
}

ManageBooking.propTypes = {
  message: PropTypes.string,
  content: PropTypes.string,
};

export default ManageBooking;
